import React from 'react';
import TablePageStyled from './TablePageStyled.jsx';
import DataTableNativeML from '@/components/DataTableNativeML';
import { useSelector } from 'dva';
import { IconButton } from '@material-ui/core';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import { useTheme } from '@material-ui/core';
import { history } from 'umi';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { OPT_ADD, OPT_DETAIL } from '@/constants';

const TablePage = (props) => {
  const { setPageData, pagination } = props;
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['activityManage/getActivityManageList'];
  const getActivityManageList = useSelector(
    (state) => state.activityManage.getActivityManageList,
  );
  const { data, total } = getActivityManageList || {};
  const theme = useTheme();
  //点击进入活动分析
  const handleClick = (record) => {
    const { code, name, dateBegin, dateEnd } = record;
    history.push({
      pathname: '/marketing/account_activity_manage/analyse',
      query: {
        code,
        name,
        dateBegin,
        dateEnd,
      },
    });
  };
  //新建活动
  const handleAddActivity = (item) => {
    history.push({
      pathname: '/marketing/account_activity_detail',
      query: {
        opt: item ? OPT_DETAIL : OPT_ADD,
        code: item ? item.code : '',
      },
    });
  };
  const columns = [
    {
      title: '活动名称',
      align: 'center',
      id: 'name',
      width: 348,
      render: (record) => {
        return (
          <span
            data-log={JSON.stringify({
              oid: 'link_marketing_activity_miniprogram_management_list_activity_name',
              events: ['_ev', '_ec'],
              params: {
                activity_id: record.id,
              },
            })}
            style={{ color: '#1565C0', cursor: 'pointer' }}
            onClick={() => handleAddActivity(record)}
          >
            {record.name}
          </span>
        );
      },
    },
    {
      title: '活动开始时间',
      align: 'center',
      id: 'dateBegin',
      width: 348,
    },
    {
      title: '活动结束时间',
      align: 'center',
      id: 'dateEnd',
      width: 348,
    },
    {
      title: '操作',
      width: 140,
      align: 'center',
      render: (record) => {
        return (
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <ButtonTip title="查看详情">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_miniprogram_management_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: record.id,
                  },
                })}
                onClick={() => handleAddActivity(record)}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="查看数据">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_miniprogram_management_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: record.id,
                  },
                })}
                onClick={() => handleClick(record)}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
              >
                <SvgIconML
                  name="data"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];
  return (
    <TablePageStyled>
      <div className="export-wrapper">
        <Fab
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          onClick={() => handleAddActivity()}
        >
          <AddIcon sx={{ width: '24px', height: '24px' }} />
          新建活动
        </Fab>
      </div>
      <DataTableNativeML
        loading={loading}
        columns={columns}
        paging={true}
        data={data}
        total={total}
        columnKey="code"
        page={pagination}
        changePage={(page) => {
          setPageData(page);
        }}
      ></DataTableNativeML>
    </TablePageStyled>
  );
};
export default TablePage;
